module.exports = __webpack_public_path__ + "static/OG_Product-scale-a0ce4f7df5a6a6510ff23fc736347426.png";